import { useRef } from 'react';

import Button from './Button';

/**
 * A button that opens the file picker.
 *
 * A <label for> styled as a button looks the same but cannot be reached with
 * the keyboard: labels take no focus. This is a real Button that clicks a
 * hidden <input type="file">. `id`, `name` and `inputRef` go to the input (a
 * form that clears the chosen file needs the ref); everything else - variant,
 * className, children - goes to the button. `disabled` applies to both.
 * `directory` picks a whole folder instead of one file (every file in it
 * arrives with its `webkitRelativePath`).
 */
function FileButton({
  accept,
  onChange,
  disabled = false,
  id,
  name,
  inputRef,
  directory = false,
  children,
  ...buttonProps
}) {
  const ownRef = useRef(null);
  const ref = inputRef ?? ownRef;

  return (
    <>
      <input
        ref={ref}
        id={id}
        name={name}
        type="file"
        accept={accept}
        hidden
        disabled={disabled}
        onChange={onChange}
        {...(directory ? { webkitdirectory: '', directory: '', multiple: true } : {})}
      />

      <Button
        {...buttonProps}
        disabled={disabled}
        onClick={() => ref.current?.click()}
      >
        {children}
      </Button>
    </>
  );
}

export default FileButton;
